import { getERPClient } from "./client";

/**
 * Content Translation API (Plan 1928 — multi-language catalog).
 *
 * Talks to zaviago_backend.storefront.api_translations on the Tenant Server.
 * The backend resolves the tenant from the session user's company when no
 * tenant key is passed (primary-store case), so `tenant` is optional.
 */

const API_BASE = "zaviago_backend.storefront.api_translations";

export type TranslationRefDoctype =
  | "Item"
  | "Item Attribute"
  | "Item Customization Template";

export interface ItemTranslationsResponse {
  /** { [languageCode]: { [fieldname]: translatedValue } } */
  languages: Record<string, Record<string, string>>;
  enabled_languages: string[];
  default_language: string;
}

export interface SaveTranslationsResult {
  saved: number;
  deleted: number;
}

export interface LanguageOption {
  /** Language code (Frappe Language doc name, e.g. "en", "th", "fil") */
  name: string;
  language_name: string;
}

export const contentTranslations = {
  async listLanguages(): Promise<LanguageOption[]> {
    const client = getERPClient();
    return client.call(`${API_BASE}.list_languages`, {}) as Promise<LanguageOption[]>;
  },

  async get(
    refDoctype: TranslationRefDoctype,
    refName: string,
    tenant?: string,
  ): Promise<ItemTranslationsResponse> {
    const client = getERPClient();
    return client.call(`${API_BASE}.get_translations`, {
      tenant: tenant ?? "",
      ref_doctype: refDoctype,
      ref_name: refName,
    }) as Promise<ItemTranslationsResponse>;
  },

  async save(
    refDoctype: TranslationRefDoctype,
    refName: string,
    translations: Record<string, Record<string, string | null>>,
    tenant?: string,
  ): Promise<SaveTranslationsResult> {
    const client = getERPClient();
    return client.call(`${API_BASE}.save_translations`, {
      tenant: tenant ?? "",
      ref_doctype: refDoctype,
      ref_name: refName,
      translations: JSON.stringify(translations),
    }) as Promise<SaveTranslationsResult>;
  },
};
